export default __webpack_public_path__ + "static/common-footer-image-b0d299926b53e63ebb3b05447a672a76.png";